
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection } from "../Shared/Shared.js";
import { union_type, class_type, record_type, bool_type, list_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { DashboardConfigurationDto_$reflection, DashboardBlockSize_$reflection, DashboardBlock_$reflection, DashboardBlockConfiguration_$reflection } from "../Shared/DashboardConfiguration.js";

export class State extends Record {
    constructor(FormState, NotificationToDelete, Draft, IsResetDialogOpen) {
        super();
        this.FormState = FormState;
        this.NotificationToDelete = NotificationToDelete;
        this.Draft = Draft;
        this.IsResetDialogOpen = IsResetDialogOpen;
    }
}

export function State_$reflection() {
    return record_type("Dashboard.Types.State", [], State, () => [["FormState", FormState_$reflection()], ["NotificationToDelete", option_type(string_type)], ["Draft", option_type(list_type(DashboardBlockConfiguration_$reflection()))], ["IsResetDialogOpen", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RequestDeleteNotification", "ConfirmDeleteNotification", "CancelDeleteNotification", "NotificationDeleted", "StartEditing", "MoveBlock", "HideBlock", "ShowBlock", "SetBlockSize", "CancelEditing", "SaveConfiguration", "ConfigurationSaved", "RequestReset", "CancelReset", "ConfirmReset", "ConfigurationReset", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.Types.Msg", [], Msg, () => [[["Item", string_type]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DashboardBlockConfiguration_$reflection())]], [["Item1", DashboardBlock_$reflection()], ["Item2", DashboardBlock_$reflection()]], [["Item", DashboardBlock_$reflection()]], [["Item", DashboardBlock_$reflection()]], [["Item1", DashboardBlock_$reflection()], ["Item2", DashboardBlockSize_$reflection()]], [], [], [["Item", ClientApiResponse$1_$reflection(DashboardConfigurationDto_$reflection())]], [], [], [], [["Item", ClientApiResponse$1_$reflection(DashboardConfigurationDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

